import React from "react";
import { useRouter } from "next/router";
import { isProspect } from "@/utils/type";

import TexasSearchPage from "../components/search/TexasSearchPage";
import NotFound from "@/components/common/NotFound";

const Search = ({ type, community }) => {
    const router = useRouter();

    return isProspect(type) ? <TexasSearchPage /> : <NotFound />;
};

// can use getStaticProps without getStaticPath, so use getServerSideProps here
export async function getServerSideProps(context) {
    // This is a special landing page for Texas search
    // it show communities in 3 cities: Houston, San Antonio, and Dallas

    return {
        props: {
            type: process.env.NEXT_PUBLIC_TYPE,
            meta: {
                title: "Texas | Purple Door",
                description: "Search for Texas on Purple Door",
                ogTitle: "Texas | Purple Door",
                ogImage:
                    "https://cdn.purpledoorfinders.com/purpledoorfinders/logo-for-meta-data.sm.webp",
                ogType: "profile",
            },
        },
    };
}

export default Search;
